module.exports = __webpack_public_path__ + "img/TCITY MAP.accfc1b8.png";